import React from "react";
import SarasTrans from "../../../library/notifications/SarasTrans";
import * as fn from "../../../helper/uiFunctions";

const DocReviewRow = (props) => {
    const { viewData, onClick } = props;

    const rowData = viewData.dataList;

    const onWorkFlowAction = (e) => {
        const elementClass = e.currentTarget.className;

        if(onClick && elementClass.indexOf("approve")>0){
            onClick(viewData.val,"approve")
        }
        else if(onClick && elementClass.indexOf("reject")>0){
            onClick(viewData.val,"reject");
        }
            
    }

    const showStatus = () => {
        if (fn.compareNumber(rowData.isApproveContainerVisible, 1)) {
            return (
                <span className="uiApprover rowColContent" >
                    <span className="uiWorkFlowIndicateApprove approve" onClick={onWorkFlowAction}></span>
                    <span className="uiWorkFlowIndicateReject reject" onClick={onWorkFlowAction}></span>
                </span>
            )
        }
        else if (fn.compareNumber(rowData.isWrkflowStatusVisible, 1)) {
            return (
                <span className={rowData.wrkflowStatusClass} >
                    {rowData.wrkflowStatus}
                </span>
            )
        }
    }

    const showReviewStatus = () => {
        if (fn.compareNumber(rowData.isWrkFlowRevDtlVisible, 1)) {
            return (
                <li id="reviewDetailCont"  >
                    <span style={{fontSize:"11px"}} ID="wrkflowRevDetCtrl" className="rowColContent" >{rowData.reviewDetail}</span>
                </li >
            )
        }
        return (null)
    }

    return (
        <li className={rowData.rowCSSClass}>
            <div className="uiApvWrkFlwActivityInfo">
                <div className="appWrkFlwRowNumber">
                    <span className="uiwrkflowActSeqNo" id="wrkflowActSeqNo" >{rowData.seqNo}</span>
                </div>
                <div className="appWrkFlowRowContent">
                    <ul>
                        <li className="wrkFlowName" ID="wrkflowActNameCtrl" >{viewData.valF}</li>
                        <li>
                            <span className="rowColName"><SarasTrans value = "Status"/></span>
                            {showStatus()}

                        </li>
                        <li>
                            <span className="rowColName"><SarasTrans value = "Reviewer"/></span>
                            <span ID="wrkflowApproverCtrl" className="rowColContent" >{rowData.wrkflowApprover}</span>
                        </li >
                        {showReviewStatus()}
                    </ul >
                </div >
            </div >
        </li>
    )
}

export default DocReviewRow